import { PageFormat } from "@redotech/redo-fulfillment-outbound-labels-common/outbound-label-enums";
import { PrintableDocument } from "@redotech/redo-model/fulfillments/print-job";
import { PageSize } from "@redotech/redo-model/packing-slips/packing-slip-builder";

export const DERMAZEN_TEAM_ID = "69e6a22324b42422b56ac9ee";

export interface PackingSlipAutoPrintTemplate {
  pageLayout: { size: PageSize };
  combineHalfPageSlips?: boolean | null;
}

export interface PackingSlipOnLabelPrintedDecisionInput {
  document: PrintableDocument;
  labelPageFormat: PageFormat;
  packingSlipPageFormat: PageFormat;
  printSlipOnLabelPrinted: boolean | null | undefined;
  teamId: string;
  packingSlips: readonly PackingSlipAutoPrintTemplate[];
}

function hasPackingSlipOnLabelPrintedBaseCondition({
  document,
  labelPageFormat,
  printSlipOnLabelPrinted,
}: PackingSlipOnLabelPrintedDecisionInput) {
  return (
    document === PrintableDocument.LABEL &&
    labelPageFormat === PageFormat.Label &&
    !!printSlipOnLabelPrinted
  );
}

export function wouldPrintPackingSlipOnLabelPrintedWithFullSizeLogic(
  input: PackingSlipOnLabelPrintedDecisionInput,
) {
  if (!hasPackingSlipOnLabelPrintedBaseCondition(input)) {
    return false;
  }

  return input.packingSlips.every(
    (t) => t.pageLayout.size === PageSize.FULL_SIZE,
  );
}

export function shouldPrintPackingSlipOnLabelPrinted(
  input: PackingSlipOnLabelPrintedDecisionInput,
) {
  if (!hasPackingSlipOnLabelPrintedBaseCondition(input)) {
    return false;
  }

  const shouldPrintDermazenMergedHalfPagePackingSlip =
    input.teamId === DERMAZEN_TEAM_ID &&
    input.packingSlipPageFormat === PageFormat.Letter &&
    input.packingSlips.length > 0 &&
    input.packingSlips.every(
      (t) =>
        t.pageLayout.size === PageSize.HALF_SIZE && !!t.combineHalfPageSlips,
    );

  return (
    wouldPrintPackingSlipOnLabelPrintedWithFullSizeLogic(input) ||
    shouldPrintDermazenMergedHalfPagePackingSlip
  );
}

export function wouldPrintPackingSlipOnLabelPrintedWithLetterFormat(
  input: PackingSlipOnLabelPrintedDecisionInput,
) {
  return (
    hasPackingSlipOnLabelPrintedBaseCondition(input) &&
    input.packingSlipPageFormat === PageFormat.Letter
  );
}
